import React, { useState } from 'react';
import TenantManager from '../../components/super-admin/TenantManager';
import { Tenant } from '../../types';

export default function SuperAdminTenantsPage() {
  const [selectedTenant, setSelectedTenant] = useState<Tenant | null>(null);

  const handleTenantSelect = (tenant: Tenant) => {
    setSelectedTenant(tenant);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Gerenciamento de Empresas</h1>
        <div className="text-sm text-gray-500 dark:text-gray-400">
          Gerencie empresas, usuários e configurações do sistema
        </div>
      </div>
      
      <TenantManager onTenantSelect={handleTenantSelect} />
      
      {selectedTenant && (
        <div className="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
          <h3 className="font-medium text-gray-900 dark:text-white">Empresa Selecionada:</h3>
          <p className="text-gray-700 dark:text-gray-300">{selectedTenant.name}</p>
        </div>
      )}
    </div>
  );
}